<template>
	<div class="bg-primary-25 w-full p-6 print:py-3">
		<h2
			class="form-title pb-6 text-2xl font-bold print:mb-3 print:border-b-2 print:border-slate-900 print:pt-2 print:pb-3 print:text-sm/0"
		>
			{{ t('plan.sectionTitle.other') }}
		</h2>

		<CopyButtonList
			field-or-section="otherMemorialNotes"
			:active-index="activePlanIndex"
			class="print:hidden"
		/>

		<section>
			<div
				class="section-grid-row grid grid-cols-1 grid-rows-1 gap-2 *:w-full *:max-w-none"
			>
				<FormKit
					type="textarea"
					auto-height
					name="otherMemorialNotes"
					:label="t('plan.notes')"
					:outer-class="{ 'mb-0': true }"
					:placeholder="t('plan.placeholders.otherMemorialNotes')"
					validation="length:0,10000"
					validation-visibility="live"
				/>
			</div>
		</section>
	</div>
</template>

<script setup lang="ts">
import CopyButtonList from '@/components/presentation/CopyButtonList.vue'
import { usePresentationLocale } from '@/i18n'
import { FormKit } from '@formkit/vue'

const { t } = usePresentationLocale()

defineProps<{
	activePlanIndex: number
}>()
</script>
